@ -1,298 +1,318 @@
<template>
  <div>
    <div class="header mb-10">
      <el-button
        @click="handleNew()"
        type="primary"
        icon="el-icon-plus"
        size="small"
        v-permission="Auth.deviceCategoryNew"
        >新增分类</el-button
      >
      <file-button
        style="float: right"
        class="mobile-hide"
        obj="item_category"
        :filter="filter"
        @importCallback="requestItemCategoryList"
        v-permission="Auth.deviceCategoryIE"
      ></file-button>
    </div>
    <el-table
      v-if="!isMobile()"
      v-loading="loading"
      :data="cates"
      stripe
      header-row-class-name="q-products-header"
    >
      <el-table-column align="left" label="分类封面">
        <template slot-scope="scope">
          <auth-img
            tag="el-image"
            style="width: 60px; height: 60px"
            :src="scope.row.cover"
            fit="cover"
          >
          </auth-img>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="分类名" align="left">
        <template slot-scope="scope">
          {{ scope.row.whole_name.replace(/,/g, ' - ') }}
        </template>
      </el-table-column>
      <el-table-column
        prop="item_count"
        label="设备数量"
        align="center"
        v-if="user.dealer_id > 0"
      ></el-table-column>
      <el-table-column
        prop="customer_device_count"
        label="客户设备数量"
        align="center"
      ></el-table-column>
      <el-table-column align="right" label="操作">
        <template
          slot-scope="scope"
          v-if="scope.row.dealer_id == user.dealer_id"
        >
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleNew(scope.row, scope.$index)"
            v-permission="Auth.deviceCategoryNew"
            >添加子分类</el-button
          >
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleEdit(scope.$index, scope.row)"
            v-permission="Auth.deviceCategoryEdit"
            >编辑</el-button
          >
          <el-popconfirm
            v-permission="Auth.deviceCategoryDelete"
            title="确认删除吗？"
            @confirm="handleDelete(scope.$index, scope.row)"
            v-if="
              scope.row.item_count == 0 && scope.row.customer_device_count == 0
            "
          >
            <el-button
              class="ml-10"
              slot="reference"
              type="danger"
              plain
              size="mini"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="(item, index) in cates" :key="item.id">
        <div style="display: flex; justify-content: space-between">
          <div>
            <div>分类名：{{ item.whole_name.replace(/,/g, ' - ') }}</div>

            <div class="text-info-12" v-if="user.dealer_id > 0">
              设备数：{{ item.item_count }}
            </div>
            <div class="text-info-12">
              客户设备数量：{{ item.customer_device_count }}
            </div>
          </div>
          <div class="text-info-12">
            <auth-img
              tag="el-image"
              style="width: 50px; height: 50px"
              :src="item.cover"
              fit="cover"
            >
              <div slot="error" class="image-slot">暂无图片</div>
            </auth-img>
          </div>
        </div>
        <div class="mt-10" v-if="item.dealer_id == user.dealer_id">
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleNew(item, index)"
            v-permission="Auth.deviceCategoryNew"
            >添加子分类</el-button
          >
          <el-button
            size="mini"
            type="primary"
            plain
            @click="handleEdit(index, item)"
            v-permission="Auth.deviceCategoryEdit"
            >编辑</el-button
          >
          <el-popconfirm
            v-permission="Auth.deviceCategoryDelete"
            title="确认删除吗？"
            @confirm="handleDelete(index, item)"
            v-if="item.item_count == 0 && item.customer_device_count == 0"
          >
            <el-button
              class="ml-10"
              slot="reference"
              type="danger"
              plain
              size="mini"
              >删除</el-button
            >
          </el-popconfirm>
        </div>
      </li>
    </ul>
    <el-pagination
      class="mt-20"
      :current-page.sync="filter.page"
      layout="total, prev, pager, next"
      @current-change="handlePageChange"
      :page-size="filter.size"
      :total="total"
    ></el-pagination>

    <item-category-former
      :model="cateForm"
      :show.sync="cateVisible"
      :cates="cates"
      @created="createdModel"
      @updated="updatedModel"
    ></item-category-former>
  </div>
</template>

<script>
import itemCategoryFormer from '@/components/item_category'
import { itemCategoryList, deleteItemCategory } from '@/service/getData'
import { clone } from '@/util'
import { isMobile } from '@/util/index'

export default {
  props: {
    filter: Object,
    user: Object,
  },
  watch: {
    filter: {
      handler(newVal) {
        this.requestItemCategoryList()
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      isMobile,
      loading: true,
      total: 0,
      cates: [],
      cateForm: {},
      cateVisible: false,
      editIndex: 0,
    }
  },
  components: {
    itemCategoryFormer,
  },
  methods: {
    async requestItemCategoryList() {
      let data = clone(this.filter)
      data.page = data.page - 1
      this.loading = true

      let res = await itemCategoryList(data)
      if (res.code == 0) {
        this.cates = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    handlePageChange(e) {
      this.filter.page = e
      this.requestItemCategoryList()
    },
    createdModel(res) {
      res.item_count = 0
      res.customer_device_count = 0
      this.cates.splice(this.editIndex, 0, res)
    },
    updatedModel(res) {
      this.cates[this.editIndex].whole_name = res.whole_name
      this.cates[this.editIndex].name = res.name
      this.cates[this.editIndex].father = res.father
      this.cates[this.editIndex].father_id = res.father.id
      this.cates[this.editIndex].cover = res.cover
    },
    handleNew(cate, index) {
      this.editIndex = 0
      let father_id = 0
      let level = 1
      let father_name = ''
      let cover = ''
      if (cate) {
        this.editIndex = index + 1
        father_id = cate.id
        father_name = cate.name
        level = cate.level + 1
        cover = cate.cover
      }
      this.cateForm = {
        name: '',
        cover: cover,
        father_id: father_id,
        level: level,
        father_name: father_name,
        category: 2,
      }
      this.cateVisible = true
    },
    handleEdit(index, item) {
      this.cateVisible = true
      this.$nextTick(() => {
        this.cateForm = clone(item)
        this.cateForm.father_name = this.cateForm.father.name
        this.editIndex = index
      })
    },

    deleteCallBack(id) {
      let cates = this.cates.filter(
        (item) => item.father_id == id || item.id == id
      )
      this.cates = this.cates.filter(
        (item) => item.father_id != id && item.id != id
      )
      if (cates.length > 0) {
        cates.map((item) => {
          this.deleteCallBack(item.id)
        })
      }
    },
    async handleDelete(index, it) {
      let res = await deleteItemCategory(it.id)
      if (res.code == 0) {
        this.deleteCallBack(it.id)
        // this.cates = this.cates.filter(
        //   item => item.father_id != it.id && item.id != it.id
        // )
      }
    },
  },
}
</script>